// @flow

// Libs
import React from 'react'
import _map from 'lodash/map'

// Containers
import listItemContainer from '../containers/ListItem'

// Components
import ListItem from './ListItem'

// Styles
import { white, text, lightGrey } from 'fc-styles/src/colors'

// Icons
import FilterIcon from 'fc-icons/src/Filter'
import ArrowForward from 'fc-icons/src/ArrowForward'
import ArrowBack from 'fc-icons/src/ArrowBack'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  filterDiv: {
    backgroundColor: 'lightgray',
    display: 'flex',
    flexDirection: 'row',
    flexShrink: '0',
    position: 'fixed',
    width: '100%',
    zIndex: '2',
    height: 25,
  },
  input: {
    width: '100%',
    border: 'none',
    backgroundColor: 'lightgray',
    outline: 'none',
    paddingLeft: '5px',
  },
  filterIcon: {
    padding: 5,
  },
  content: {
    paddingTop: 25,
    paddingBottom: 30,
  },
  paginator: {
    width: '100%',
    height: 30,
    position: 'fixed',
    backgroundColor: white(),
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  back: {
    marginRight: 10,
    padding: 7,
  },
  forward: {
    marginLeft: 10,
    padding: 7,
  },
  pageNumber: {
    paddingTop: 5,
  },
}

const filterIcon = <FilterIcon style={styles.filterIcon} size={15} color={white()} />
const backIcon = <ArrowBack size={15} color={text()} />
const disabledBackIcon = <ArrowBack size={15} color={lightGrey()} />
const forwardIcon = <ArrowForward size={15} color={text()} />
const disabledForwardIcon = <ArrowForward size={15} color={lightGrey()} />

// Types
type Props = {
  columns?: Array<Object>,
  defaultColumn: string,
  records: Array<Object>,
  toggled: boolean,
  onToggle: Function,
  renderer: Function,
  filters: Object,
  onFilter: Function,
  onPaginateLeft: Function,
  onPaginateRight: Function,
  page: number,
  pages: Array<Object>,
}


export class ListItems extends React.Component {
  props: Props

  onFilter: Function

  constructor (props: Object) {
    super(props)
    this.onFilter = this.onFilter.bind(this)
  }

  onFilter (e: Object) {
    this.props.onFilter({
      attr: this.props.defaultColumn,
      value: e.target.value,
    })
  }

  render (): React.Element<any> {
    return (
      <div style={styles.container} >
        <div style={styles.filterDiv}>{filterIcon}
          <input
            onChange={this.onFilter}
            value={this.props.filters[this.props.defaultColumn]}
            style={styles.input}
          />
        </div>
        <div style={styles.content}>
          {_map(this.props.records, (record: Object): React.Element<any> =>
            <ListItem
              record={record}
              defaultColumn={this.props.defaultColumn}
              columns={this.props.columns}
              toggled={this.props.toggled}
              onToggle={this.props.onToggle}
              renderer={this.props.renderer}
              key={record[this.props.defaultColumn]}
            />
          )}
        </div>
        <div style={styles.paginator}>
          <div
            style={styles.back}
            onClick={this.props.onPaginateLeft}>{this.props.page === 0 ? disabledBackIcon : backIcon}
          </div>
          <div style={styles.pageNumber}>{this.props.page + 1}{'/'}{this.props.pages.length}</div>
          <div
            style={styles.forward}
            onClick={this.props.onPaginateRight}>{this.props.page === this.props.pages.length - 1
              ? disabledForwardIcon : forwardIcon}
          </div>
        </div>
      </div>
    )
  }
}

export default listItemContainer(ListItems)
